// components/RepresentativeCardModal.js
import React from 'react';
import './RepresentativeCardModal.css';

function RepresentativeCardModal({ deck, mainCardId, setMainCardId, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>代表カードを選択</h3>
        <div className="card-list-main">
          {deck.map(card => (
            <div
              key={card.card_id}
              className={`card-option ${mainCardId === card.card_id ? 'selected' : ''}`}
              onClick={() => setMainCardId(card.card_id)}
              title={card.card_name} // ホバーでカード名表示
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/${card.card_image}`}
                alt={card.card_name}
                style={{ width: 60 }}
              />
            </div>
          ))}
        </div>
        <div className="modal-buttons">
          <button onClick={onConfirm} disabled={!mainCardId}>確定</button>
          <button onClick={onCancel}>キャンセル</button>
        </div>
      </div>
    </div>
  );
}

export default RepresentativeCardModal;
